import { FC } from "react";
import { Route, Switch } from "react-router";

import { RouteWithSubRoutes, IRoute } from "@router";
import DynamicReport from "@/pages/client/DynamicReport";

const Routes: FC<{ routes: IRoute[] }> = ({ routes }) => {
  return (
    <Switch>
      {routes.map(route => (
        <RouteWithSubRoutes {...route} />
      ))}

      <Route component={() => <DynamicReport />} />
    </Switch>
  );
};

export default Routes;
